module.exports = __webpack_public_path__ + "static/img/4.a96dae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/4.png
// module id = iqwG
// module chunks = 0